import { HeaderNames } from './PHP/HTTP/HeaderNames'

// vxapp headers
export const Header = {
  Auth: 'Authorization',
  Api: HeaderNames.API_GUID,
}
